const { html } = window;

export default ({nextRecommendation}) => `
        <p>${html('accountLimitsPanel.rtlNoneRemaining', {time: nextRecommendation})}</p>
    
        <div class="button-container">
            <button type='button' class='confirm-button button radius secondary contrast u-allCaps'>${html('ok')}</button>
        </div>
`;
